import { render } from "./OpSlots.vue?vue&type=template&id=0b16c117&scoped=true"
import script from "./OpSlots.vue?vue&type=script&lang=js"
export * from "./OpSlots.vue?vue&type=script&lang=js"

import "./OpSlots.vue?vue&type=style&index=0&id=0b16c117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16c117"]])

export default __exports__